/**
 * @fileoverview Provides a utility function for streaming AI chat completions to the console. It supports different models, prompts, and optional prediction input with configurable streaming behavior. The function also handles timing performance.
 */

import { print_ai_stream, print_ai_stream_code } from '@iterator/shared-node/util/logging'
import { streamChatCompletions } from './ai/llm_api'
import { print_ai } from '@iterator/shared-node/util/logging'
import { debug_block } from '@iterator/shared-node/util/logging'
import { Message, Model } from '@iterator/shared-node/ai/llm_types'
import { time } from '@iterator/shared-node/util/timing'
import { AiStreamer } from './ai_streamer'

export async function streamToConsole(
  model: Model,
  systemPrompt: string,
  texts: string[],
  userPrompt: string,
  stream: boolean = true,
  prediction?: string,
): Promise<{ message: Message }> {
  const streamer = new AiStreamer(print_ai_stream, print_ai_stream_code)
  const { message, timing } = await time('streamChatCompletions', async () => {
    return streamChatCompletions(
      systemPrompt,
      texts,
      [{ role: 'user', content: userPrompt }],
      (chunk) => {
        if (stream) {
          streamer.stream(chunk)
        }
      },
      model,
      prediction,
    )
  })
  if (stream) {
    print_ai('') // Add a newline after streaming.
  }
  debug_block('Timing', timing)
  return { message }
}
